<script>
import { mapState } from 'vuex'
import Sidebar from '@components/profile/sidebar.vue'
import { breakpointsMixin } from '../mixins/breakpointsMixin'

export default {
  name: 'Profile',
  components: {
    Sidebar
  },
  data () {
    return {
      hideRouterView: true
    }
  },
  mixins: [breakpointsMixin],
  created () {
    if (window.ga) {
      window.ga('set', 'page', '/profile')
      window.ga('send', 'pageview')
    }
  },
  async mounted () {
    if (!localStorage.getItem('pcc-user')) {
      this.$bvModal.show('modal-login')
    }
    if (this.$router.history.current.path.includes('/profile') && !localStorage.getItem('pcc-user')) {
      this.hideRouterView = false
    }
  },
  computed: mapState(['user']),
  methods: {}
}
</script>

<template>
  <b-container id="profile" fluid>
    <div v-if="user" class="row c">
      <div transition v-if="isDesktopView || (!isDesktopView && hideRouterView)" :class="['col-4', { full: !isDesktopView && hideRouterView, isMobile: !isDesktopView}]">
        <Sidebar :isMobile="!isDesktopView" @hide-router-view="hideRouterView = false"/>
      </div>
      <div transition v-if="isDesktopView || (!isDesktopView && !hideRouterView)" :class="['col sub-route-container', { full: !isDesktopView && !hideRouterView, isMobile: !isDesktopView}]">
        <router-view
          @hide-router-view="hideRouterView = true"
          :isMobile="!isDesktopView"
          :hideRouterView="hideRouterView"
        >
        </router-view>
      </div>
    </div>
  </b-container>
</template>

<style lang="scss">
#profile {
  position: relative;
  padding: 0rem 6vw;
  min-height: calc(100vh - 13.5rem);
  .c {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  .col-4 {
    max-width: 30rem;
    &.isMobile {
      &.full {
        max-width: 100%;
        width: 100%;
        flex: 0 0 100%;
        .sidebar-container {
          border-right: unset;
          padding-right: unset;
          .option {
            &:not(.logout) {
              background-color: rgba(black, 0.04);
              &:hover {
                background-color: rgba(black, 0.1);
              }
            }
            margin-bottom: 0.3rem;
            span {
              margin-left: 3rem;
            }
          }
        }
      }
    }
  }
  .sub-route-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    &.isMobile {
      &.full {
        padding-right: unset;
        padding-left: unset;
        .payment-block-container {
          padding-right: unset;
          padding-left: unset;
          .payment-list {
            padding-right: unset;
            padding-left: unset;
          }
        }
        .info-container {
          padding-right: unset;
          padding-left: unset;
          .avatar-container {
            flex-direction: column;
            margin-bottom: 1rem;
            button {
              width: fit-content;
              @media screen and (max-width: 500px) {
                width: 75%;
                align-self: center;
              }
            }
          }
          .submit {
            width: 84%;
            margin: auto;
            margin-top: 1rem;
          }
        }
        .sub-container {
          padding-right: unset;
          padding-left: unset;
          .buttons-container {
            flex-direction: column;
            div {
              width: 100%;
              flex-direction: column;
              align-items: center;
              button {
                width: 80%;
              }
              .change {
                margin-right: unset;
                margin-bottom: 1rem;
              }
            }
            .cancel {
              margin-top: 1rem;
            }
          }
        }
        .payment-container {
          padding-right: unset;
          padding-left: unset;
          .card-name {
            flex-direction: column;
            align-items: center;
            text-align: center;
            .nick-name {
              display: flex;
              justify-content: center;
            }
            .number {
              @extend .nick-name;
            }
          }
          .edit-btn {
            display: flex;
            justify-content: center;
            button {
              width: 80%;
            }
          }
          form {
            .edit {
              width: 80%;
              margin: auto;
              margin-top: 1rem;
            }
          }
        }
        .pw-container {
          .col-5 {
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>
